'use client';

import { ReactNode } from 'react';

import { TravelDataCard, TravelDataProps } from '@/tournament/components/details/TravelDataCard';

interface TravelInfoProps {
	title: string;
	prefixIcon?: ReactNode;
	data: TravelDataProps[];
}

export const TravelInfoList = (props: TravelInfoProps) => {
	const { title, prefixIcon, data } = props;

	return (
		<>
			{data && data.length > 0 && (
				<div className="flex flex-col gap-3 rounded-lg border p-4 sm:border-none sm:p-0">
					<div className="text-xl font-medium text-gray-900">
						<span className="mr-3">{prefixIcon}</span>
						{title}
					</div>
					<div className="flex flex-col gap-4 sm:grid sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
						{data.map((item, i) => (
							<TravelDataCard
								key={i}
								title={item.title}
								streetAddr={item.streetAddr}
								city={item.city}
								state={item.state}
								zip={item.zip}
								url={item.url}
								milesFromVenue={item.milesFromVenue}
								details={item.details}
							/>
						))}
					</div>
				</div>
			)}
		</>
	);
};
